import { useEffect } from 'react';

import { useJobProspectsStatsActions } from './JobProspectsStatsContext';
import { getExternalJobBoardsStats } from './restApi';

const ExternalJobBoardsStatsLoader = () => {
  const { initializeState, onResponse, onError } = useJobProspectsStatsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getExternalJobBoardsStats({ onResponse, onError });
  }, []);

  return null;
};

export default ExternalJobBoardsStatsLoader;
